import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Paginator } from 'primereact/paginator';
import { Growl } from 'primereact/growl';
import servicioHttp from '../servicios/ServicioHttp';
import servicioObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioFormatos from '../servicios/ServicioFormatos';
import logo_upload from '../../../src/imagen/IconUpload.png'

export class FacturacionLayoutTelepeaje extends Component {
    constructor() {
        super();
        this.state = {
            mostrarModalResultado: false,
            listaResultados: [],
            botonFacturacion: false,
            ttLayoutTelepeaje: null,            
            paginacion: {
                registrosPorPagina: 20,
                join: { "tcEmisor": "alias_tcEmisor" },

            },
            inicio: 0,
            mostrarModalResultadoFacturacion:false,
            resultadoFacturacion:{},
            elIdLayout:null,
            mostrarModalEliminar:false
        };

        this.obtenerLayouts();
    }

    obtenerLayouts = () => {
        let { paginacion } = this.state;
        servicioHttp.consumirPostHttp('/layout_telepeaje/paginacion.json', paginacion).then(response => {
            this.setState({
                paginacion:response.data.objeto
            });
        }).catch(error => {

        });
    }

    onDrop = (files) => {
        let formData = new FormData();
        formData.append('layout', files[0]);
        servicioHttp.consumirPostHttp('/layout_telepeaje/procesar.json', formData).then(response => {
            this.setState({
                mostrarModalResultado: true,
                listaResultados: response.data.lista,
                botonFacturacion: response.data.error,
                ttLayoutTelepeaje: response.data.objeto
            });
            this.obtenerLayouts();
        }).catch(error => {
            this.growl.show({ severity: 'error', summary: 'Error', detail: "Existe un error desconocido al procesar el layout", life: 5000 });
        });
    };

    facturarLayout = (id) => {                
        if (!servicioObjetos.esObjetoVacio(id)) {
            servicioHttp.consumirPostHttp('/layout_telepeaje/timbrar.json', {id:id}).then(response => {                
                this.setState({
                    resultadoFacturacion:response.data.objeto,
                    mostrarModalResultadoFacturacion:true
                });
                this.obtenerLayouts();
            }).catch(error => {
                this.growl.show({ severity: 'error', summary: 'Error', detail: "Existe un error desconocido al timbrar el layout", life: 5000 });
            });
        }
    }

    cerrarModalResultados = () => {
        this.setState({ mostrarModalResultado: false });
    }

    cerrarModalResultadoFacturacion = () => {
        this.setState({ mostrarModalResultadoFacturacion :false});
    }

    columnaObservacion = (rowData, column) => {
        return <p >{rowData}</p>;
    }

    cambiaPagina = (event) => {
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ inicio: event.first, paginacion });
        this.obtenerLayouts();
    }

    mostrarEliminarLayout = (idLayout) => {
        this.setState({ mostrarModalEliminar: true, elIdLayout: idLayout });
    }

    cerrarEliminarLayout = () => {
        this.setState({ mostrarModalEliminar: false, elIdLayout: null });
    }

    eliminarLayout = () => {
        let {elIdLayout}=this.state;
        servicioHttp.consumirPostHttp('/layout_telepeaje/eliminar.json',{id:elIdLayout}).then(response => {
            this.cerrarEliminarLayout();
            this.growl.show({ severity: 'success', summary: 'Éxito', detail: "Layout eliminado con éxito", life: 5000 });
            this.obtenerLayouts();
        }).catch(error => {
            this.growl.show({ severity: 'error', summary: 'Error', detail: "Existe un error desconocido al eliminar el layout", life: 5000 });
        });
    }

    templateAutorizarTimbrado = (rowData, column) => {
        return 0 === rowData[3] ? <Button icon="pi-md-check" onClick={() => this.facturarLayout(rowData[0])} label="Facturar" className="teal-btn flat-btn" /> : null;
    }

    templateEliminarLayout = (rowData, column) => {
        return 0 === rowData[3] ? <Button tooltip="Eliminar layout" type="button" icon="pi-md-delete" className="p-button-warning" onClick={() => this.mostrarEliminarLayout(rowData[0])}/> : null;
    }

    templateColumnaFecha = (rowData, column) => {
        return servicioFormatos.formatearFechaYYYYMMDDHHmmss(rowData[4]);
    }

    templateColumnaEstado = (rowData, column) =>{        
        let resultado="";        
        switch (rowData[3]) {
            case 0:
                resultado="Creado";
                break;
            case 1:
                resultado="Timbrando";
                break;
            case 2:
                resultado="Timbrado";
                break;
            default:
                break;    
        }

        return resultado;
    }

    descargarDetalle = () => {
        let {resultadoFacturacion} =this.state;
        let {resultados} =resultadoFacturacion;
        let renglones=[];
        for(let i=0;i<resultados.length;i++){
            let elemento=resultados[i];
            let renglon=elemento.idCuenta+"|"+elemento.idCliente+"|"+elemento.rfc+"|"+elemento.nombre+" => uuid:"+elemento.uuid+"|"+elemento.errores+"\n";
            renglones.push(renglon);
        }
        let result = ''.concat(...renglones);
        var link = document.createElement('a');
        link.download = 'resultados.txt';
        var blob = new Blob([result], {type: 'text/plain'});
        link.href = window.URL.createObjectURL(blob);
        link.click();
    }
    
    render() {

        let { mostrarModalResultado, listaResultados, paginacion,
            inicio, mostrarModalResultadoFacturacion, resultadoFacturacion, mostrarModalEliminar } = this.state;

        const piePaginaModalRestultados = (
            <div>
                {false ? <Button icon="pi-md-check" onClick={this.facturarLayout} label="Facturar" className="teal-btn flat-btn" /> : null}
                <Button label="Aceptar" icon="pi pi-times" onClick={this.cerrarModalResultados} />
            </div>
        );

        const piePaginaModalRestultadosFacturacion = (
            <div>
                <Button label="Aceptar" icon="pi-md-check" onClick={this.cerrarModalResultadoFacturacion} />
            </div>
        );

        const piePaginaModalEliminar = (
            <div>
                <Button label="Si" icon="pi pi-check" onClick={this.eliminarLayout} />
                <Button label="No" icon="pi pi-times" className="p-button-secondary" onClick={this.cerrarEliminarLayout} />
            </div>
        );

        return (
            <div className="p-fluid">
                <Growl ref={(el) => this.growl = el} />
                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="card">
                            <div className="p-grid">
                                <div className="p-col-8"><h2>Facturación de Layout Telepeaje</h2></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="card">
                            <div className="p-grid">
                                
                                <div className="p-col-12  p-md-12">
                                    <Dropzone accept=".xlsx" onDrop={this.onDrop}>
                                        {({ getRootProps, getInputProps }) => (
                                            <section className="container container__center">
                                                <div  {...getRootProps({ className: 'dropzone rectangulo' })}>
                                                    <input   {...getInputProps()} />
                                                    <img className="rectangulo-img-upload" src={logo_upload} alt='upload'/>
                                                    <p className="rectangulo-p-upload">Arrastra y suelta aquí los archivos .xlsx para validarlos</p>                                                    
                                                </div>
                                            </section>
                                        )}
                                    </Dropzone>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="card">
                            <DataTable value={paginacion.datos} header="LAYOUTS REGISTRADOS" responsive={true} resizableColumns={true}>
                                <Column body={this.templateAutorizarTimbrado} style={{textAlign:'center'}} autoLayout={true} resizableColumns={true}/>
                                <Column field="1" header="RFC Emisor" style={{textAlign:'center'}} autoLayout={true} resizableColumns={true}/>
                                <Column field="2" header="Nombre Archivo" style={{textAlign:'center'}} autoLayout={true} resizableColumns={true}/>
                                <Column body={this.templateColumnaFecha} style={{textAlign:'center'}} header="Fecha Carga" autoLayout={true} resizableColumns={true}/>
                                <Column body={this.templateColumnaEstado} style={{textAlign:'center'}} header="Estado" autoLayout={true} resizableColumns={true}/>
                                <Column body={this.templateEliminarLayout} style={{textAlign:'center'}} header="Eliminar" autoLayout={true} resizableColumns={true}/>
                            </DataTable>
                            <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
                        </div>
                    </div>
                </div>

                <Dialog header="Información Procesada" visible={mostrarModalResultado} modal={true} closeOnEscape={false} closable={false} footer={piePaginaModalRestultados} onHide={this.cerrarModalResultados} appendTo={document.body}>
                    <DataTable value={listaResultados} header="Resultado" responsive={true} scrollable={true} scrollHeight="200px">
                        <Column body={this.columnaObservacion} header="Observacion" />
                    </DataTable>
                </Dialog>
                <Dialog header="Resultado Facturación" visible={mostrarModalResultadoFacturacion} modal={true} closeOnEscape={false} closable={false} footer={piePaginaModalRestultadosFacturacion} onHide={this.cerrarModalResultadoFacturacion} appendTo={document.body}>
                    <div className="p-grid">
                        <div className="p-col-12">
                            <div className="card">
                                <div className="p-grid">
                                    <div className="p-col-12 p-md-12">Total:<strong>{resultadoFacturacion.total}</strong></div>
                                    <div className="p-col-12 p-md-12">Facturados:<strong>{resultadoFacturacion.timbradas}</strong></div>
                                    <div className="p-col-12 p-md-12">No Facturados:<strong>{resultadoFacturacion.noTimbradas}</strong></div>
                                    <div className="p-col-12 p-md-12"><Button label="Descargar Detalle" icon="pi-md-file-download" onClick={  this.descargarDetalle} /> </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Dialog>
                <Dialog header="¿Eliminar el layout?" visible={mostrarModalEliminar} modal={true} closeOnEscape={false} closable={false} footer={piePaginaModalEliminar} onHide={this.cerrarEliminarLayout} appendTo={document.body}>
                        ¿Está usted seguro de eliminar el Layout ?
                </Dialog>
            </div>
        );
    }

}